module.exports = __webpack_public_path__ + "static/img/scene4.f3f6359f.jpg";